/** Name list parsing, shared by the control and by whoever seeds it. */

const SEPARATORS = /[,;\n\r]+/;

/** Shortest and longest a participant name may be, matching the API rules. */
export const NAME_MIN_LENGTH = 2;
export const NAME_MAX_LENGTH = 64;

/** Trim and case-fold, so "Anna" and "anna " are the same person. */
export function normalizeName(name: string): string {
  return (name || '').trim().toLowerCase();
}

/** Split a typed or pasted blob on commas, semicolons and newlines. */
export function parseNames(raw: string): string[] {
  return (raw || '')
    .split(SEPARATORS)
    .map((part) => part.trim())
    .filter(Boolean);
}

export function isValidName(name: string): boolean {
  const trimmed = (name || '').trim();
  return trimmed.length >= NAME_MIN_LENGTH && trimmed.length <= NAME_MAX_LENGTH;
}

export function isDuplicateName(name: string, existing: string[]): boolean {
  const normalized = normalizeName(name);
  return Boolean(normalized) && existing.some((item) => normalizeName(item) === normalized);
}
